import React, { useState, useEffect, useMemo } from 'react';
import DocumentTable from './table';
import Navbar from '../navbar';
import { getMeta, loadAssociatedDocuments } from '../../api/external';
import AuthService from '../externalauthentication/authservice';
import { getThumbnail, loadDocument } from '../../api/external';
import { isModernApi } from '../../index';
import jwt from 'jsonwebtoken';

function Documents() {
  const auth = useMemo(() => new AuthService(), []);
  const [documents, setDocuments] = useState([]);
  const [images, setImages] = useState({});
  const [meta, setMeta] = useState({});

  useEffect(
    () => {
      const loadDocuments = async () => {
        console.log('table did mount');

        console.log('created auth');
        const user = await auth.getUser();
        console.log('show user');
        console.log(user);
        let loadedDocuments = [];
        let loadedMeta = {};
        if (isModernApi()) {
          const token: any = jwt.decode(user.access_token);
          const docIds = token.s_documents;
          console.log('docIds', docIds);
          for (const id of docIds) {
            console.log('id', id);
            loadedDocuments.push(await loadDocument(user, id));
          }
          loadedMeta = await getMeta(user);
        } else {
          loadedDocuments = await loadAssociatedDocuments(user);
        }
        let loadedImages = {};
        if (loadedDocuments && loadedDocuments.length > 0) {
          for (let i = 0; i < loadedDocuments.length; i++) {
            const document = loadedDocuments[i];
            const thumb = await getThumbnail(user, document.id);
            if (isModernApi()) {
              loadedImages[document.id] = thumb;
            } else {
              loadedImages[document.id] = toBase64(thumb);
            }
          }
        }
        setDocuments(loadedDocuments);
        setImages(loadedImages);
        setMeta(loadedMeta);
      };

      loadDocuments();
    },
    [auth]
  );

  const toBase64 = buffer => {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  return (
    <div style={{ height: '100%', minHeight: '100%' }}>
      <Navbar />
      <div style={{ maxWidth: '90%', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center' }}>Available Documents</h2>
        <DocumentTable documents={documents} images={images} meta={meta} />
      </div>
    </div>
  );
}

export default Documents;
